import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./arrow-right-line.svg?react";

export const ArrowRightLineIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
